import http from '@admin/http';

export async function updateRefundReserve(projectId: string, baseMultiplier: number) {
  await http.put(`/lnpl/v1/projects/${projectId}/refund-reserve`, { baseMultiplier });
}
